import { Component, Token } from "@siteimprove/alfa-css";
import { Iterable } from "@siteimprove/alfa-iterable";
import { Parser } from "@siteimprove/alfa-parser";
import { Slice } from "@siteimprove/alfa-slice";
import { Query } from "./query.js";
const { either, end, map, separatedList, takeUntil } = Parser;
/**
 * {@link https://drafts.csswg.org/mediaqueries-5/#media-query-list}
 *
 * @public
 */
export class List {
    static of(queries) {
        return new List(queries);
    }
    _queries;
    constructor(queries) {
        this._queries = Array.from(queries);
    }
    get queries() {
        return this._queries;
    }
    matches(device) {
        return (this._queries.length === 0 ||
            this._queries.some((query) => query.matches(device)));
    }
    equals(value) {
        return (value instanceof List &&
            value._queries.length === this._queries.length &&
            value._queries.every((query, i) => query.equals(this._queries[i])));
    }
    *[Symbol.iterator]() {
        yield* this._queries;
    }
    toJSON() {
        return this._queries.map((query) => query.toJSON());
    }
    toString() {
        return this._queries.join(", ");
    }
}
/**
 * @public
 */
(function (List) {
    function isList(value) {
        return value instanceof List;
    }
    List.isList = isList;
    /**
     * {@link https://drafts.csswg.org/mediaqueries-5/#typedef-media-query-list}
     */
    List.parse = map(separatedList(map(takeUntil(Component.consume, either(Token.parseComma, end(() => `Unexpected token`))), (components) => Iterable.flatten(components)), Token.parseComma), (queries) => List.of(Iterable.map(queries, (tokens) => Query.parse(Slice.from(tokens).trim(Token.isWhitespace))
        .map(([, query]) => query)
        .getOr(Query.notAll))));
})(List || (List = {}));
//# sourceMappingURL=list.js.map